import { Button, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import {
    borderStyle,
    boxHeight,
    defaultGap,
    smallGap,
} from "../../../styles/consts";

export default function PageNavigation({
  page,
  setPage,
  filteredItems,
  visibleRowsNo,
  callOnNextPage,
  storageKey,
}: {
  page: number;
  setPage: any;
  filteredItems: any[] | number;
  visibleRowsNo: number;
  callOnNextPage?: () => void;
  storageKey?: string;
}) {
  const itemsCount = Array.isArray(filteredItems) ? filteredItems.length : filteredItems;
  const amountOfPages = Math.ceil(itemsCount / visibleRowsNo);

  useEffect(() => {
    if (storageKey) {
      localStorage.setItem(storageKey, page.toString());
    }
  }, [page, storageKey]);

  return (
    <Stack
      sx={{
        borderTop: borderStyle,
        height: boxHeight,
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        minHeight: boxHeight,
        maxHeight: boxHeight,
        padding: `0.75rem ${defaultGap} ${smallGap}`,
        boxSizing: "border-box",
        alignItems: "center",
      }}
    >
      <Button
        variant="navigation"
        onClick={() => {
          if (page === 1) {
            return;
          }
          setPage((prev) => prev - 1);
        }}
        disabled={page === 1}
      >
        Previous
      </Button>
      <Typography>
        Page {page} of {amountOfPages === 0 ? 1 : amountOfPages}
      </Typography>
      <Button
        variant="navigation"
        onClick={() => {
          setPage((prev) => {
            if (prev * visibleRowsNo > itemsCount) {
              return prev;
            }
            return prev + 1;
          });
          callOnNextPage && callOnNextPage();
        }}
        disabled={page * visibleRowsNo >= itemsCount}
      >
        Next
      </Button>
    </Stack>
  );
}
